export const UPDATE_SEARCH = 'UPDATE_SEARCH'
export const UPDATE_SEARCH_PAGINATION = 'UPDATE_SEARCH_PAGINATION'
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM'
export const UPDATE_TREE_OBJECT = 'UPDATE_TREE_OBJECT'
export const UPDATE_SELECTED_KEYS = 'UPDATE_SELECTED_KEYS'
